import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import BalanceRefill from 'desktop/components/BalanceRefill/BalanceRefill';
import Link from 'shared/components/Link/Link';
import withBalance from 'shared/hocs/withBalance';
import creditCardImg from 'shared/assets/images/credit-card.svg';

import s from './Balance.css';

class Balance extends React.Component {
  static propTypes = {
    balance: PropTypes.number,
  };
  static defaultProps = {
    balance: null,
  };

  state = {
    isPopupOpened: false,
    shouldFreeze: false,
  };

  togglePopup = e => {
    e.preventDefault();
    this.setState(({ isPopupOpened }) => ({ isPopupOpened: !isPopupOpened }));
  };

  handleClickOutside = () => {
    if (!this.state.shouldFreeze) {
      this.setState({ isPopupOpened: false });
    }
  };

  handleModalOpen = () => {
    this.setState({ shouldFreeze: true });
  };

  handleModalClose = () => {
    this.setState({ shouldFreeze: false });
  };

  render() {
    const { balance } = this.props;
    const { isPopupOpened } = this.state;

    if (balance === null) {
      return null;
    }

    return (
      <div className={s.root}>
        <Link to="/billing/" className={s.content} onClick={this.togglePopup}>
          <img className={s.icon} src={creditCardImg} alt="" height={22} />
          {'  '} <span className={s.title}>{balance} грн</span>
        </Link>

        <ReactCSSTransitionGroup
          transitionName="fadeUp"
          transitionEnterTimeout={100}
          transitionLeaveTimeout={100}
        >
          {isPopupOpened &&
            <div className={s.popup}>
              <BalanceRefill
                onModalOpen={this.handleModalOpen}
                onModalClose={this.handleModalClose}
              />
            </div>}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default withStyles(s)(withBalance()(onClickOutside(Balance)));



// WEBPACK FOOTER //
// ./src/desktop/components/Balance/Balance.js